var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF6CA1;stroke:#242424;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40,48H8c-4.4,0-8-3.6-8-8V8c0-4.4,3.6-8,8-8h32c4.4,0,8,3.6,8,8v32C48,44.4,44.4,48,40,48z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.5,35.3L12.7,15.5c-0.8-0.8-0.8-2.1,0-2.8l0,0c0.8-0.8,2.1-0.8,2.8,0l19.8,19.8c0.8,0.8,0.8,2.1,0,2.8l0,0 C34.5,36.1,33.3,36.1,32.5,35.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.7,32.5l19.8-19.8c0.8-0.8,2.1-0.8,2.8,0l0,0c0.8,0.8,0.8,2.1,0,2.8L15.5,35.3c-0.8,0.8-2.1,0.8-2.8,0l0,0 C11.9,34.5,11.9,33.3,12.7,32.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.a41761cdf9f1524c24e7771bd2e1bb4c.svg";
export { ForwardRef as ReactComponent };